import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: `${rem(279)}`,

    [theme.breakpoints.down('sm')]: {
      minWidth: `${rem(250)}`,
    },
  },
}));

// Buckets a flat list into groups, keeping the order in which each group first appears.
const groupMenuItems = (menuItems) => {
  const groups = new Map();
  menuItems.forEach((item) => {
    if (!groups.has(item.group)) {
      groups.set(item.group, []);
    }
    groups.get(item.group).push(item);
  });
  return groups;
};

const GroupedSelect = ({ children, disabled, id, inputLabel, labelId, menuItems, value, ...props }) => {
  const classes = useStyles();

  const renderMenuItems = () =>
    [...groupMenuItems(menuItems)].flatMap(([group, items]) => [
      // Group headers are disabled items so they can never be picked.
      <MenuItem value="" disabled key={`${group}-group-header`}>
        <em>{group}</em>
      </MenuItem>,
      ...items.map((item, index) => (
        <MenuItem value={item.code} key={`${group}-${item.code}-${index}`}>
          {item.value}
        </MenuItem>
      )),
    ]);

  return (
    <FormControl variant="outlined" className={classes.root} disabled={disabled}>
      <InputLabel id={labelId} variant="outlined">
        {inputLabel}
      </InputLabel>
      <MuiSelect labelId={labelId} label={inputLabel} id={id} value={value} autoWidth {...props}>
        {menuItems ? renderMenuItems() : children}
      </MuiSelect>
    </FormControl>
  );
};

GroupedSelect.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inputLabel: PropTypes.string,
  labelId: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      group: PropTypes.string,
      value: PropTypes.string,
      code: PropTypes.string,
    }),
  ),
  value: PropTypes.string,
};

export default GroupedSelect;
